import { ProcessingStatus } from '@/hooks/useKeyValOperations';

export const APP_ROUTES = {
  ONBOARDING: '/ui/onboarding',
  HOME: '/ui',
  MY_WORKFORCE: '/ui/my-workforce',
  SIGN_IN: '/ui/sign-in',
  SIGN_UP: '/ui/sign-up',
  AEO: '/ui/agent/aeo',
  REPORTS: '/ui/reports',
}

/**
 * Namespaced app-level role stored in the Clerk org membership public metadata
 * `roles` array. A guest is restricted to a read-only view of these routes.
 */
export const GUEST_ROLE = 'strive:guest';

/**
 * Route prefixes a guest may access. Any other route redirects to Reports.
 * Keep this in sync with the backend `allow_guest` route allowlist.
 */
export const GUEST_ALLOWED_ROUTE_PREFIXES = [ APP_ROUTES.AEO, APP_ROUTES.REPORTS ];

export const MULTI_EXECUTION_AGENTS = ['blog-post-content-strategizer', 'blog-post-content-refresher'];
export const REVIEW_BASED_AGENTS = ['negative-keyword-analyzer'];
export const HEADLESS_AGENTS = ['blog-post-draft-writing', 'global-chat-agent', 'report-builder'];

// List of routes that are publicly accessible without authentication
export const publicRoutes = [
  APP_ROUTES.SIGN_IN,
  APP_ROUTES.SIGN_UP,
];

// List of common personal email domains
export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'protonmail.com',
  'mail.com',
  'zoho.com',
  'yandex.com',
  'live.com',
  'inbox.com',
  'gmx.com',
  'fastmail.com',
  'me.com'
];

// Screens where config CTA is enabled
export const CONFIG_CTA_ENABLED_SCREENS = ['idle', 'completed'];

export const showCreateOrg = true; // Flag to control create org option visibility

// Export navigation constants
export * from './navigation';

// Sidebar supported agents - these agents have to pass the props to output screen
export const SIDEBAR_SUPPORTED_AGENTS = [
  "google-ads-campaign-analyser",
  "linkedin-ads-campaign-analyser",
  "sales-battle-card-generator",
];

export const VARIABLE_CATEGORY_MAPPING = {
  "primary_variables": "1"
}

export const BRAND_NAME_SHORT_NAME = "brand_name";
export const BRAND_DESCRIPTION_SHORT_NAME = "brand_description";
export const COMPETITORS_SHORT_NAME = "competitors";
export const COMPETITOR_DOMAINS_SHORT_NAME = "competitor_domains";
export const OWN_PRODUCTS_SHORT_NAME = "own_products";
export const BRAND_WRITING_GUIDELINES_SHORT_NAME = "brand_writing_guidelines";
export const BRAND_WRITING_RULES_SHORT_NAME = "brand_writing_rules";
export const BRAND_DOMAIN_SHORT_NAME = "brand_domain";
export const BLOG_URL_SHORT_NAME = "blog_url";
export const PRIMARY_SEARCH_LOCATION_SHORT_NAME = "primary_search_location";
export const SECONDARY_SEARCH_LOCATIONS_SHORT_NAME = "secondary_search_locations";
export const BRAND_AUDIENCES_SHORT_NAME = "brand_audiences";
export const BRAND_VOICE_TONE_SHORT_NAME = "brand_voice_tone";

export const POLLING_INTERVAL = 15000; // Poll every 15 seconds

export const statusConfig = {
  [ProcessingStatus.PENDING]: {
    label: "Todo",
    color: "text-gray-600"
  },
  [ProcessingStatus.IN_PROGRESS]: {
    label: "In Progress",
    color: "text-gray-600"
  },
  [ProcessingStatus.COMPLETED]: {
    label: "Done",
    color: "text-emerald-500"
  },
  [ProcessingStatus.WAITING_FOR_APPROVAL]: {
    label: "Review",
    color: "text-blue-600"
  },
  [ProcessingStatus.FAILED]: {
    label: "Failed",
    color: "text-red-500"
  }
};

// List of StriveLabs internal users — gates Marketplace, Experiments, and other internal-only features.
// `e2e+clerk_test@strivelabs.ai` is the Playwright dev/staging test user; including it here lets the
// E2E suite exercise internal-gated routes (Glossary, Marketplace, Experiments) the same way real
// internal users hit them, instead of branching `if (navItem.exists) click else goto` in every spec.
// The prod e2e user uses `mari@strivelabs.ai` which is already in the list.
export const STRIVELABS_USERS: string[] = [
  'mari@strivelabs.ai',
  'raghuram@strivelabs.ai',
  'arunkumar@strivelabs.ai',
  'jahirbasha.nabadulla@strivelabs.ai',
  'sakthivel@strivelabs.ai',
  'satwik@strivelabs.ai',
  'gb@strivelabs.ai',
  'aadharsh@strivelabs.ai',
  'e2e+clerk_test@strivelabs.ai',
  'kishor@strivelabs.ai'
];
